<!-- 规则常显提示 -->
<span class="info">
    {{i18n.cdpConfigPolicySTip}}
</span>

<form [formGroup]="newExecutionCycleVm"
    [errorMessage]="newExecutionCycleErrorMessage">
    <div #newExecutionCyclePanel>
        <div *ngFor="let executionCycle of executionCycleCtrs?.controls; let i = index;"
            [formGroup]="executionCycle"
            class="vm-content mt-10">
            <!-- 执行周期时间参数 -->
            <div class="cdp-create-s-execution-cycle">
                <span class="mr-10">{{i18n.title.eachLab}}</span>
                <div class="inline-flex-wrapper" class="w-500">
                    <!-- 秒 -->
                    <n-spinner
                        *ngIf="executionCycle.get('executionCycleWay').value === FrequenciesE.SECONDLY"
                        class="w-250"
                        [onlyInput]="true"
                        [min]="minSecond"
                        [max]="HyperCdpConfigPolicySSecondValue.MAX"
                        formControlName="second">
                    </n-spinner>
                    <span *ngIf="executionCycle.get('executionCycleWay').value === FrequenciesE.SECONDLY"
                        class="w-88">
                        {{i18n.title.rangeResult| fn: minSecond : HyperCdpConfigPolicySSecondValue.MAX}}
                    </span>

                    <!-- 分 -->
                    <n-spinner
                        *ngIf="executionCycle.get('executionCycleWay').value === FrequenciesE.MINUTELY"
                        class="w-250"
                        [onlyInput]="true"
                        [min]="HyperCdpConfigPolicySMinuteValue.MIN"
                        [max]="HyperCdpConfigPolicySMinuteValue.MAX"
                        formControlName="minute">
                    </n-spinner>
                    <span *ngIf="executionCycle.get('executionCycleWay').value === FrequenciesE.MINUTELY"
                        class="w-88">
                        {{i18n.title.rangeResult| fn: minuteMin : HyperCdpConfigPolicySMinuteValue.MAX}}
                    </span>

                    <!-- 时 -->
                    <n-spinner
                        *ngIf="executionCycle.get('executionCycleWay').value === FrequenciesE.HOURLY"
                        class="w-250"
                        [onlyInput]="true"
                        [min]="HyperCdpConfigPolicySHourValue.MIN"
                        [max]="HyperCdpConfigPolicySHourValue.MAX"
                        formControlName="hour">
                    </n-spinner>
                    <span *ngIf="executionCycle.get('executionCycleWay').value === FrequenciesE.HOURLY"
                        class="w-88">
                        {{i18n.title.rangeResult| fn: HyperCdpConfigPolicySHourValue.MIN :
                        HyperCdpConfigPolicySHourValue.MAX}}
                    </span>

                    <!-- 周期选择 -->
                    <n-select
                        id="config-policy-s-execution-cycle-way-{{i}}"
                        [ngStyle]="{'width': executionCycle.get('executionCycleWay').value ? '0.8rem' : '4.18rem'}"
                        [options]="timeUnitOpts"
                        [placeholder]="i18n.title.placeHolderContext"
                        formControlName="executionCycleWay"
                        (onOverlayVisibleChange)="changeTimeUnitOpts(i)"
                        (onChange)="onExecutionCycleWayChange($event, i)">
                    </n-select>

                    <n-tip type="failed"
                        calss="failed-tip"
                        *ngIf="executionCycle.get('executionCycleWay').errors && (executionCycle.get('executionCycleWay').dirty || executionCycle.get('executionCycleWay').touched)"
                        [styleType]="'tooltip'">
                        <span *ngFor="let err of [(executionCycle.get('executionCycleWay').errors | keys)[0]]">
                            {{newExecutionCycleErrorMessage.executionCycleWay[err]}}
                        </span>
                    </n-tip>

                    <!-- 天 -->
                    <div *ngIf="executionCycle.get('executionCycleWay').value === FrequenciesE.DAILY"
                        class="ml-25">
                        <n-multi-select
                            [options]="hourOpt"
                            [placeholder]="i18n.title.hour"
                            formControlName="dailyHour">
                        </n-multi-select>
                        <n-tip type="failed"
                            calss="failed-tip"
                            *ngIf="executionCycle.get('dailyHour').errors && (executionCycle.get('dailyHour').dirty || executionCycle.get('dailyHour').touched)"
                            [styleType]="'tooltip'">
                            <span *ngFor="let err of [(executionCycle.get('dailyHour').errors | keys)[0]]">
                                {{newExecutionCycleErrorMessage.dailyHour[err]}}
                            </span>
                        </n-tip>
                        <span class="ml-10 mr-10">{{':'}}</span>
                        <n-spinner
                            id="config-policy-s-execution-daily-minute-{{i}}"
                            [onlyInput]="true"
                            class="w-90"
                            [min]="HyperCdpConfigPolicySDailyMinuteValue.MIN"
                            [max]="HyperCdpConfigPolicySDailyMinuteValue.MAX"
                            [placeHolder]="i18n.title.minuteLabel"
                            formControlName="dailyMinute">
                        </n-spinner>
                        <span>{{i18n.title.rangeResult| fn: HyperCdpConfigPolicySDailyMinuteValue.MIN :
                            HyperCdpConfigPolicySDailyMinuteValue.MAX}}</span>
                    </div>

                    <!-- 周 -->
                    <div *ngIf="executionCycle.get('executionCycleWay').value === FrequenciesE.WEEKLY"
                        class="ml-25">
                        <n-multi-select
                            [options]="dateOpt"
                            [placeholder]="i18n.title.week"
                            formControlName="weeklyDay">
                        </n-multi-select>
                        <n-tip type="failed"
                            calss="failed-tip"
                            *ngIf="executionCycle.get('weeklyDay').errors && (executionCycle.get('weeklyDay').dirty || executionCycle.get('weeklyDay').touched)"
                            [styleType]="'tooltip'">
                            <span *ngFor="let err of [(executionCycle.get('weeklyDay').errors | keys)[0]]">
                                {{newExecutionCycleErrorMessage.weeklyDay[err]}}
                            </span>
                        </n-tip>
                        <n-time
                            class="ml-23 w-90"
                            formControlName="weeklyTime"
                            [showSeconds]="false">
                        </n-time>
                    </div>
                    <!-- 月 -->
                    <div *ngIf="executionCycle.get('executionCycleWay').value === FrequenciesE.MONTHLY"
                        class="ml-25">
                        <n-multi-select
                            [options]="mouthlyDayOpt"
                            [placeholder]="i18n.title.date"
                            formControlName="mouthlyDay">
                        </n-multi-select>
                        <n-tip type="failed"
                            calss="failed-tip"
                            *ngIf="executionCycle.get('mouthlyDay').errors && (executionCycle.get('mouthlyDay').dirty || executionCycle.get('mouthlyDay').touched)"
                            [styleType]="'tooltip'">
                            <span *ngFor="let err of [(executionCycle.get('mouthlyDay').errors | keys)[0]]">
                                {{newExecutionCycleErrorMessage.mouthlyDay[err]}}
                            </span>
                        </n-tip>
                        <n-time
                            class="ml-23 w-90"
                            formControlName="mouthlyTime"
                            [showSeconds]="false">
                        </n-time>
                    </div>
                </div>
            </div>

            <!-- 留存副本 -->
            <div class="inline-flex-wrapper ml-20"
                *ngIf="isNeedNumber(executionCycle.get('executionCycleWay').value)">
                <span>{{i18n.title.retainLab}}</span>
                <n-spinner
                    id="config-policy-s-execution-retain-number-{{i}}"
                    [min]="HyperCdpConfigPolicySRetainValue.MIN"
                    [max]="numberMaxValue(executionCycle.get('executionCycleWay').value)"
                    class="w-90"
                    formControlName="number">
                </n-spinner>
                <span>{{i18n.title.copiesNumberLab}}</span>
            </div>

            <!-- 删除按钮 -->
            <div>
                <button nButton
                    class="icon-btn ml-20"
                    type="button"
                    icon="icon-close"
                    [border]="false"
                    (click)="deleteNewExecutionCycle(i)">
                </button>
            </div>
        </div>
    </div>

    <!-- 添加按钮 -->
    <button nButton
        id="config-policy-s-add-btn"
        type="button"
        theme="text"
        class="add-btn"
        icon="app-icon-config-policy-s-add-btn"
        [label]="i18n.title.addBtn"
        [disabled]="isAddExecutionCycleBtnDisabled"
        [disabledTips]="i18n.atMostFourCdpSchedule"
        (click)="addNewExecutionCycle()">
    </button>
</form>

<n-tip type="failed"
    *ngIf="isLessThanExecutionCycle"
    [content]="i18n.atLeastOneCdpSchedule">
</n-tip>